// extracted by mini-css-extract-plugin
export default {"callButton":"CallButton_callButton__EWLmu","icon":"CallButton_icon__tqs9W"};